
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import React, {Fragment, useEffect, useRef, useState} from 'react';
import { useMembershipApplication } from 'context/ApplicationContext';
import ApiClient from 'rest/ApiClient';
// import DebounceButton from "components/debounce-button/DebounceButton";
import LandingBanner from 'components/landing-banner/LandingBanner';
import GradientButton from "components/gradient-button/GradientButton";
import DownloadCardModal from "components/download-card-modal/DownloadCardModal";
import PassRestoreModal from "components/pass-restore-modal/PassRestoreModal";

type ContainerProps = {
  backgroundImage?: string;
};
const Container = styled.div<ContainerProps>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  user-select: none;
  //padding: 20px 0;
  box-sizing: border-box;
  //clip-path: path('M 0 200 L 0,75 A 5,5 0,0,1 150,75 L 200 200 z');
  background: radial-gradient(
      70% 40% at 110% 100%,
      rgba(209, 208, 198, 0.7) 0%,
      #ff000000 100%
    ),
    radial-gradient(
      60% 70% at 0% 100%,
      rgba(255, 255, 254, 1) 0%,
      #ff000000 100%
    ),
    linear-gradient(
      270deg,
      rgba(210, 210, 203, 0.5) 0%,
      rgba(231, 231, 224, 0.5) 100%
    );

  font-size: calc(8px + var(--root-view-width) * 0.017);
  font-family: Montserrat, sans-serif;

  ${(props) => {
    if (props.backgroundImage) {
      return `
				background: url(${props.backgroundImage}) center;
	      background-size: cover;
	      
	    `;
    }
    return null;
  }};
`;

const TitleText = styled.div`
  max-width: 75%;
  //margin-bottom: 0.5rem;
  display: block;
  font-size: 1.7em;
  font-weight: bold;
  //background: linear-gradient(90deg, rgba(173,134,65,1) 0%, rgba(198,185,81,1) 100%);
  background: linear-gradient(
    90deg,
    rgba(178, 144, 68, 1) 0%,
    rgba(199, 185, 82, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.02em;
`;
const TextContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  //justify-content: space-evenly;
  justify-content: start;
  flex-grow: 1;
  //margin: 4% 0;
  margin-top: 4%;
  align-items: center;
`;
const DetailsContainer = styled.div`
  width: 90%;
  padding: 0.5em 0;
  font-size: 0.9em;
  font-weight: 500;
  & ul,
  ol {
    list-style-position: inside;
    text-align: left;
    //line-height: 1.8em;
    //margin-block-start: 0;
    //padding-inline-start: 0;
    padding-inline: 1em;
    & li {
      padding: 0.5em 0;
    }
  }
`;
// const PrimaryButton = styled(DebounceButton)`
const PrimaryButton = styled.button`
  appearance: none;
  width: 85%;
  //margin-top: 0.5em;
  //margin-top: auto;
  height: 50px;
  border: none;
  font-family: Montserrat, system-ui, sans-serif;
  font-size: 1.2em;
  font-weight: 600;
  border-radius: 25px;
  background: linear-gradient(
    90deg,
    rgba(173, 134, 65, 1) 0%,
    rgba(198, 185, 81, 1) 100%
  );
  //border-radius: 8px;
  //background: linear-gradient(135deg, #1e34f5, #6026ef);
  color: white;
  transition: all 0.1s ease-in-out;
  &:active {
    transform: scale(0.98);
    opacity: 0.5;
  }
`;

export const PoweredByLogo = styled.img`
  //width: 80px;
  height: 8vh;
  margin: 0 0 -1vh 0;
  //object-fit: contain;
`;

interface ModalRef {
  showModal: () => void;
}


export const LandingPage = () => {
  let navigate = useNavigate();
  const { appState, setUserInfo } = useMembershipApplication();

  const downloadCardModalRef = useRef<ModalRef | null>(null);

  useEffect(() => {
    // reset user state
    setUserInfo({});
  }, [setUserInfo]);

  // 	const homeContent  = `
  // 		<p>The ${appState.theme?.displayName} Rewards allows you to accumulate Rewards Points by simply using your card within the Club.</p>
  // 			<ul>
  // 				<li>something</li>
  // 				<li>other thing</li>
  // 				<li>And so much more!</li>
  // 				<li>See our full range of benefits <a href={'https://www.google.com'}>here</a></li>
  // 			</ul>
  // 		<p>Sign up now to ${appState.theme?.displayName} Rewards and start receiving your benefits today!</p>
  // `;

  const startSignUpFlow = () => {
    // navigate(`/${ApiClient.venueKey}/licence`, { replace: true });
    setUserInfo({ isVisitor: false });
    navigate(`/${ApiClient.venueKey}/licence`);
  };

  const startVisitorFlow = () => {
    // navigate(`/${ApiClient.venueKey}/licence`, { replace: true });
    setUserInfo({ isVisitor: true });
    navigate(`/${ApiClient.venueKey}/licence`);
  };


  return (
    <Container /* backgroundImage={appState.theme?.coverBackgroundImgUrl} */>

      <DownloadCardModal ref={downloadCardModalRef} />
      <PassRestoreModal />

      <LandingBanner
        coverBackgroundImgUrl={appState.theme?.coverBackgroundImgUrl}
        logoImageUrl={appState.theme?.logoImgUrl}
      />
      <TextContentContainer>
        <TitleText>Welcome to {appState.theme?.displayName} Rewards</TitleText>
        {/* show benefits of membership before showing onboarding the licence capture step */}
        {/* TODO: change to setHTML when enough browser coverage - or sanitise manually */}
        {/* setHTML - https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTML */}

        {appState.theme?.enableVisitorSignups ? (
          <DetailsContainer
            dangerouslySetInnerHTML={{
              __html: appState.theme?.homeShortRichHtml ?? "",
            }}
          />
        ) : (
          <DetailsContainer
            dangerouslySetInnerHTML={{
              __html: appState.theme?.homePageRichHtml ?? "",
            }}
          />
        )}

        { appState.theme?.enableVisitorSignups ? (
          <div style={{marginTop: 'auto', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px'}}>
            <TitleText><small><small>Join or renew as member now</small></small></TitleText>
            <PrimaryButton onClick={startSignUpFlow}>GET STARTED</PrimaryButton>
            {/*<PrimaryButton onClick={startSignUpFlow}>JOIN AS MEMBER</PrimaryButton>*/}
            {/*<GradientButton title="CONTINUE AS VISITOR" onClick={startVisitorFlow} />*/}
          </div>
        ) : (
          <PrimaryButton style={{marginTop: 'auto'}} onClick={startSignUpFlow}>Get Started</PrimaryButton>
        )}

        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            downloadCardModalRef.current?.showModal();
          }}
        >
          <p className="mb-6 mt-4 font-light text-sm text-gray-500 hover:text-gray-900 dark:text-gray-400">
            Already signed Up? Click to Download your card
          </p>
        </a>

        {appState.theme?.enableVisitorSignups && (
          <div style={{marginTop: 'auto', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px'}}>
            <p>Just Visiting? Click continue to sign in</p>
            <GradientButton title="CONTINUE AS VISITOR" onClick={startVisitorFlow} />
          </div>
        )}

      </TextContentContainer>
      {/*<div>Powered by Player Elite</div>*/}
      <PoweredByLogo src={`../assets/images/poweredby-gold.png`} />
    </Container>
  );
};
